export function Tabs() {
  return (
    <div>
      <h1 className="text-3xl font-bold">Tabs</h1>
    </div>
  );
}

